/**
 * Estilo ÚNICO da waveform — usado tanto na GRAVAÇÃO (ao vivo, canvas próprio em
 * AudioRecorder) quanto na PRÉVIA antes de enviar (WaveSurfer.renderFunction em
 * AudioPreview), pra ficarem idênticas ("padrão"). Mexer aqui muda os dois.
 *
 * - Barra 2px, gap 2px, cantos 2px.
 * - Altura NORMALIZADA pelo maior pico (igual WaveSurfer normalize:true).
 * - GAMMA < 1 realça as barras mais baixas (ex: pós-início, quando o AGC abaixa
 *   o ganho) sem mexer no pico (1^g = 1). Menor = barras baixas sobem mais.
 *
 * Tanto a gravação (|byte-128|/128) quanto a prévia (|amostra float|) entregam
 * picos no mesmo intervalo 0..1, então o piso/gamma valem pros dois.
 */
export const WAVE_BAR_CSS = 2;
export const WAVE_GAP_CSS = 2;
export const WAVE_RADIUS_CSS = 2;
export const WAVE_GAMMA = 0.6;
export const WAVE_NORM_FLOOR = 0.15;

/** Fração de altura (0..1) de uma barra: normaliza pelo maior pico + aplica gamma. */
export function shapeWaveAmp(peak: number, maxPeak: number): number {
  const scale = 1 / Math.max(maxPeak, WAVE_NORM_FLOOR);
  return Math.min(1, peak * scale) ** WAVE_GAMMA;
}

/**
 * Altura (0..1) de uma barra NO BALÃO (mensagem enviada/recebida). Diferente do
 * gravador/prévia: NÃO normaliza pelo pico do áudio — usa um GANHO FIXO, então a
 * altura reflete o VOLUME REAL (áudio baixo = ondas baixas), igual ao WhatsApp,
 * e fica consistente entre entrada e saída. Sem gamma (linear) pra não inflar os
 * trechos baixos. `WAVE_BUBBLE_GAIN` é o ajuste: maior = ondas mais altas.
 */
export const WAVE_BUBBLE_GAIN = 2.2;
export function shapeBubbleAmp(value: number): number {
  return Math.min(1, Math.max(0, value) * WAVE_BUBBLE_GAIN);
}
